import { t, tp } from "../constant/translations";

export const TODAY = new Date();

export function isServiceActive(service) {
  if (!service.end_date) return true;
  return new Date(service.end_date) >= TODAY;
}

export function serviceStatus(service) {
  if (!isServiceActive(service)) return "ended";
  if (service.scheduled_change) return "scheduled";
  return "active";
}

export function relFuture(d) {
  if (!d) return "";
  const dt = d instanceof Date ? d : new Date(d);
  const n = Math.round((dt - TODAY) / 86400000);
  if (n <= 0) return t("contract.line.today");
  if (n === 1) return t("contract.line.tomorrow");
  if (n < 45) return tp("contract.line.in_days", { n });
  return tp("contract.line.in_months", { n: Math.round(n / 30) });
}

export function previewAmount(base, type, value) {
  const num = parseFloat(String(value).replace(",", "."));
  const b = parseFloat(base);
  if (type === "pct") {
    if (isNaN(num)) return b;
    return Math.round(b * (1 + num / 100) * 100) / 100;
  }
  if (type === "price") {
    if (isNaN(num)) return b;
    return Math.round(num * 100) / 100;
  }
  return b;
}

export function scheduledDelta(sc) {
  if (!sc) return "";
  if (sc.type === "end") return t("contract.line.change_type_end");
  if (sc.type === "pct") {
    const v = parseFloat(sc.value);
    return `${v >= 0 ? "+" : ""}${v}%`;
  }
  return t("contract.line.change_type_price");
}

export function actionLabel(action) {
  const map = {
    create: "contract.line.action_create",
    update: "contract.line.action_update",
    partial_update: "contract.line.action_update",
    destroy: "contract.line.action_destroy",
    apply_scheduled: "contract.line.action_applied",
  };
  return t(map[action] || action);
}
